import { render, staticRenderFns } from "./detailLbRightDown.vue?vue&type=template&id=49d2eb97&scoped=true"
import script from "./detailLbRightDown.vue?vue&type=script&lang=js"
export * from "./detailLbRightDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d2eb97",
  null
  
)

export default component.exports